import { GestureModule } from 'ZalamoLibrary/src/lib/core/gestures/gesture.module';
import { createClient } from 'graphql-ws';
import {
  Observable,
  Subject,
  delay,
  filter,
  from,
  map as mapApolloResult,
  observable,
  of,
  pluck,
  retry,
  retryWhen,
  shareReplay,
  switchMap,
  tap,
  timeout,
  zip,
} from 'rxjs';
import { apolloErrorDetails } from 'ZalamoLibrary/src/lib/core/graphql/apollo-error-details';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
// import { ApmErrorHandler, ApmService } from '@elastic/apm-rum-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FakeContainerComponent } from './modules/helpers/fake-container/fake-container.component';
import { BottomIconModule } from '@ui/bottom-icon/bottom-icon.module';
import { SupportModule } from '@ui/support/support.module';
import { NavigationModule } from '@ui/navigation/navigation.module';
import { CustomizationModule } from '@ui/customization/customization.module';
import {
  MetaReducer,
  select,
  Store,
  StoreModule,
  USER_PROVIDED_META_REDUCERS,
} from '@ngrx/store';
import { ButtonModule } from '@ui/button/button/button.module';
import { AutofocusFixModule } from 'ZalamoLibrary/src/lib/ui/autofocus/autofocus.module';
import { ZalamoDialogModule } from '@ui/zalamo-dialog/zalamo-dialog.module';
import { EffectsModule } from '@ngrx/effects';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { RouterModule } from '@angular/router';
import { ScreenRecordModule } from '@ui/screen-record/screen-record.module';
import { ContainerComponent } from './components/container/container.component';
import { CommonModule } from '@angular/common';
import { AuthGuard } from 'ZalamoLibrary/src/lib/zalamo/auth/guards/auth.guard';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import {
  ApolloClientOptions,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  split,
} from '@apollo/client/core';
import { AuthModule } from '../../../zalamo-library/src/lib/zalamo/auth/auth.module';
import { JWT_TOKEN_LOCATION } from '../../../zalamo-library/src/lib/zalamo/auth/jwtlocator.service';
import { TranslationLoaderService } from '@ui/nls/translations/translation-loader.service';
import { TranslationsModule } from '@ui/nls/translations/translations.module';
import { setContext } from '@apollo/client/link/context';
import { SWUpdatesService } from 'ZalamoLibrary/src/lib/core/swupdates.service';
import { OrganizationModule } from 'ZalamoLibrary/src/lib/core/organizations/organization/organization/organization.module';
import { basicApolloToIdList } from 'graphql/basicIds';
import { VersionComponent } from './components/version/version.component';
import { MatSelectModule } from '@angular/material/select';

import {
  JWT_AUTH_STATE_CLEANUP_HANDLERS,
  JWTService,
} from 'ZalamoLibrary/src/lib/zalamo/auth/jwt-parser-service';
import { DeviceService } from 'ZalamoLibrary/src/lib/zalamo/auth/device.service';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { CurrenciesModule } from 'ZalamoLibrary/src/lib/zalamo/currencies/currencies.module';
import {
  IS_PHOTOGRAPHER,
  PROVIDE_USER_TYPE,
  ViewerType,
} from '../../../zalamo-library/src/lib/zalamo/user/ViewerType';
import { OrdersServicesModule } from '@ui/orders/orders-services/orders-services.module';
import { ErrorLink } from '@apollo/client/link/error';
import { NotificationsComponent } from 'ZalamoLibrary/src/lib/ui/notifications/notifications.component';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { IS_DEV } from 'projects/zalamo-library/src/lib/ui/translator/types';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import '@angular/common/locales/global/pl';
import { PhotographerHomeComponent } from './components/photographer-home/photographer-home.component';
import { NotificationService } from 'ZalamoLibrary/src/lib/ui/notifications/notification.service';


import { WallartPreviewModule } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/WYSIWYG/wallart/wallart-preview/wallart-preview.module';
import { WallartComponent } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/WYSIWYG/wallart/wallart.component';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ResponsivenessModule } from 'ZalamoLibrary/src/lib/ui/responsive/responsiveness/responsiveness.module';
import { WatermarkManagementModule } from './modules/watermark-management/watermark-management.module';
import { WatermarkForPhotoManagerComponent } from './modules/watermark-management/watermark-for-photo-manager/watermark-for-photo-manager.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { QuillModule } from 'ngx-quill';

import { AlbumTestComponent } from './components/album-test/album-test.component';
import { ColorizeComponent } from './components/tests/colorize/colorize.component';
import { PickerComponent } from './components/tests/picker/picker.component';
import { DateTime, Settings } from 'luxon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ZalamoInlineHelpModule } from 'ZalamoLibrary/src/lib/ui/zalamo-inline-help/zalamo-inline-help.module';
import { LastSeenPublicSessionsComponent } from './components/quick-previews/last-seen-public-sessions/last-seen-public-sessions.component';
import { PublicSessionCreatedComponent } from './components/photographer-home/events/public-session-created/public-session-created.component';
import { OrganizationMemberModule } from 'ZalamoLibrary/src/lib/ui/organization-member/organization-member.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LuxonModule } from 'luxon-angular';
import { RelativeTimePipeModule } from 'ZalamoLibrary/src/lib/core/pipes/relative-time-pipe/relative-time-pipe.module';
import { QuickLinkModule } from 'ZalamoLibrary/src/lib/ui/quick-link/quick-link/quick-link.module';
import { QuickCoverModule } from 'ZalamoLibrary/src/lib/ui/quick-cover/quick-cover.module';
import { PublicSessionOrganizationGroupNameModule } from 'ZalamoLibrary/src/lib/zalamo/pipes/public-session-organization-group-name/public-session-organization-group-name.module';
import { PublicSessionOrganizerOrganizationNameModule } from 'ZalamoLibrary/src/lib/zalamo/pipes/public-session-organizer-organization-name/public-session-organizer-organization-name.module';
import { PublicSessionDeactivatedComponent } from './components/photographer-home/events/public-session-deactivated/public-session-deactivated.component';
import { SessionStatsComponent } from './components/photographer-home/events/session-stats/session-stats.component';
import {
  SessionStatsDisplayRangeLabelPipe,
  SessionStatsDisplayTitlePipe,
  SessionStatsPeriodPipe,
  SessionStatsTopOrderSessionsPipe,
  SessionStatsTopPublicSessionOrganizationGroupsByOrdersPipe,
  SessionStatsTopPublicSessionOrganizationsByOrdersPipe,
  SessionStatsVisitsPipe,
} from './components/photographer-home/events/session-stats/session-stats.pipes';
import { ZalamoWelcomeMessageComponent } from './components/photographer-home/events/zalamo-welcome-message/zalamo-welcome-message.component';
import { MatIconModule } from '@angular/material/icon';
import { RetryLink } from '@apollo/client/link/retry';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { ZalamoUpdateComponent } from './components/photographer-home/events/zalamo-update/zalamo-update.component';
import { AnimatrixComponent } from './components/tests/animatrix/animatrix.component';
import { WallartMultiComponent } from './components/wallart-multi/wallart-multi.component';
import { SingleFileUploaderModule } from 'ZalamoLibrary/src/lib/upload/components/single-file-uploader/single-file-uploader.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import {
  CUSTOMIZATION_SCHEMA,
  CustomizationEditorSchema,
} from 'ZalamoLibrary/src/lib/ui/customization/types';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarCdkVirtualScroll } from 'ngx-scrollbar/cdk';
import { VisualGuideModule } from 'ZalamoLibrary/src/lib/ui/visual-guide/visual-guide.module';
import { VisualGuideTesterComponent } from './components/visual-guide-tester/visual-guide-tester.component';
import { MatButtonModule } from '@angular/material/button';
import { LookBookCreatedComponent } from './components/photographer-home/events/look-book-created/look-book-created.component';
import { ZalamoElementNameModule } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/zalamo-element-name/zalamo-element-name.module';
import { LookBookOrderPlacedComponent } from './components/photographer-home/events/look-book-order-placed/look-book-order-placed.component';
import { ImagesModule } from 'ZalamoLibrary/src/lib/ui/images/images.module';
import { LookBookVisitedByClientComponent } from './components/photographer-home/events/look-book-visited-by-client/look-book-visited-by-client.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { PrintsComponent } from './components/prints/prints.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LastSeenPrivateSessionsComponent } from './components/quick-previews/last-seen-private-sessions/last-seen-private-sessions.component';
import { PrivateesionVisitedByClientComponent } from './components/photographer-home/events/privateesion-visited-by-client/privateesion-visited-by-client.component';
import { DateHourPickerModule } from 'ZalamoLibrary/src/lib/ui/date-hour-picker/date-hour-picker.module';
import { WallDecorFrontModule } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/wall-decor-front.module';
import { WallDecorSceneCreatorComponent } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/wall-decor-scene-creator/wall-decor-scene-creator.component';
import { ShowPrintFromDiskPipe } from './components/prints/sho-print-from-disk.pipe';
import { ZalamoTimeService } from 'ZalamoLibrary/src/lib/zalamo/user/zalamo-time.service';
import { PhotographerWallOrderPlacedComponent } from './components/photographer-home/events/photographer-wall-order-placed/photographer-wall-order-placed.component';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { VirtualScrollModule } from 'ZalamoLibrary/src/lib/ui/virtual-scroll/virtual-scroll.module';
import { QuickImageListPreviewComponent } from './components/quick-previews/quick-image-list-preview/quick-image-list-preview.component';
import { PrivateSessionCreatedComponent } from './components/photographer-home/events/private-session-created/private-session-created.component';
import { DesignerComponent } from './components/designer/designer.component';
import { SwipeableComponent } from 'ZalamoLibrary/src/lib/ui/swipeable/swipeable/swipeable.component';
import { SwipeableModule } from 'ZalamoLibrary/src/lib/ui/swipeable/swipeable.module';
import { IccComponent } from './components/icc/icc.component';
import { ZalamoLocalClientModule } from 'ZalamoLibrary/src/lib/ui/zalamo-local-client/zalamo-local-client.module';
import { FramesQuickOrderComponent } from './components/frames-quick-order/frames-quick-order.component';
import { NumberPickerModule } from 'ZalamoLibrary/src/lib/ui/change-number/change-number.module';
import { ImageListPickerModule } from 'ZalamoLibrary/src/lib/ui/form/image-list-picker/image-list-picker.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IMAGE_MANAGEMENT_URL } from 'ZalamoLibrary/src/lib/zalamo/photo-manager/consts';
import { FormModule } from 'ZalamoLibrary/src/lib/ui/form/form.module';
import { CheckboxModule } from 'ZalamoLibrary/src/lib/ui/form/checkbox/checkbox.module';
import { devModules } from './dev.modules';
import {
  ApmErrorHandler,
  ApmModule,
  ApmService,
} from '@elastic/apm-rum-angular';
import { PdfTestComponent } from './components/pdf-test/pdf-test.component';
import { FramesComponent } from './components/frames/frames.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { queriesInProgress$ } from './components/container/inProgressCount';
import { ProtectedImageComponent } from './components/protected-image/protected-image.component';
import { ChildNameTestingComponent } from '@ui/tablo-generator/child-name/child-name-testing/child-name-testing.component';
import { TabloGeneratorModule } from '@ui/tablo-generator/tablo-generator.module';
import { PrivateSessionDeactivatedComponent } from './components/photographer-home/events/private-session-deactivated/private-session-deactivated.component';
import { selectAuthStateState } from 'ZalamoLibrary/src/lib/zalamo/auth/redux/auth-state.selectors';
import { setCurrentOrganization } from 'ZalamoLibrary/src/lib/core/organizations/organization/redux/organization.actions';
import { MineOrganizationsGQL } from 'ZalamoLibrary/src/lib/core/organizations/organization-member/graphql';
import { HideFromOrganizationMemberModule } from 'ZalamoLibrary/src/lib/core/organizations/organization-member/hide-from-organization-member/hide-from-organization-member.module';
import { CnComponent } from './components/cn/cn.component';
import { ZalamoPayRegisterP24Component } from '@ui/zalamo-pay/zalamo-pay-register-p24/zalamo-pay-register-p24.component';
import { ZalamoPayModule } from '@ui/zalamo-pay/zalamo-pay.module';
import { IframeBridgeComponent } from './components/iframe-bridge/iframe-bridge.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { BlackFridayComponent } from './components/black-friday/black-friday.component';
import { KstatsComponent } from './components/kstats/kstats.component';
import { SsltestComponent } from './components/ssltest/ssltest.component';
import { TRANSLATION_CONTEXT } from '@ui/nls/translations/consts';
import { AiChallangeComponent } from './components/ai-challange/ai-challange.component';
import { CreateTabloDemoSessionRedirectComponent } from './components/create-tablo-demo-session-redirect/create-tablo-demo-session-redirect.component';
import { DeviceLogoutSubscriptionService } from './device-logout-subscription.service';
import { OrderListCacheService } from '@ui/orders/services/order-list-cache.service';
import { FiscalMachineStateQuestionComponent } from './components/fiscal-machine-state-question/fiscal-machine-state-question.component';

Settings.defaultLocale = 'pl';

export function getMetaReducers(): MetaReducer<any>[] {
  return [];
}

const websocketReconnected = new Subject();
let websocketConnectedForFirstTime = false;
setTimeout(() => {
  console.log(DateTime.now().toISO());
}, 5000);

function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    FakeContainerComponent,
    ContainerComponent,
    FiscalMachineStateQuestionComponent,
    VersionComponent,
    AlbumTestComponent,
    ColorizeComponent,
    PickerComponent,
    LastSeenPublicSessionsComponent,
    PhotographerHomeComponent,
    PublicSessionCreatedComponent,
    PublicSessionDeactivatedComponent,
    SessionStatsComponent,
    SessionStatsPeriodPipe,
    SessionStatsDisplayTitlePipe,
    SessionStatsDisplayRangeLabelPipe,
    SessionStatsVisitsPipe,
    SessionStatsTopOrderSessionsPipe,
    SessionStatsTopPublicSessionOrganizationsByOrdersPipe,
    SessionStatsTopPublicSessionOrganizationGroupsByOrdersPipe,
    ZalamoWelcomeMessageComponent,
    ZalamoUpdateComponent,
    AnimatrixComponent,
    WallartMultiComponent,
    WallartMultiComponent,
    VisualGuideTesterComponent,
    LookBookCreatedComponent,
    LookBookOrderPlacedComponent,
    LookBookVisitedByClientComponent,
    PrintsComponent,
    LastSeenPrivateSessionsComponent,
    PrivateesionVisitedByClientComponent,
    ShowPrintFromDiskPipe,
    PhotographerWallOrderPlacedComponent,
    PrivateSessionCreatedComponent,
    DesignerComponent,
    IccComponent,
    FramesQuickOrderComponent,
    PdfTestComponent,
    FramesComponent,
    ProtectedImageComponent,
    PrivateSessionDeactivatedComponent,
    CnComponent,
    IframeBridgeComponent,
    BlackFridayComponent,
    KstatsComponent,
    SsltestComponent,
    AiChallangeComponent,
    CreateTabloDemoSessionRedirectComponent,
  ],
  bootstrap: [AppComponent],
  exports: [LookBookOrderPlacedComponent, PrivateesionVisitedByClientComponent],
  imports: [
    QuickImageListPreviewComponent,
    AppRoutingModule,
    BottomIconModule,
    SupportModule,
    NavigationModule,
    CustomizationModule,
    StoreModule.forRoot([]),
    ZalamoInlineHelpModule,
    ApmModule,
    ButtonModule,
    AutofocusFixModule,
    CheckboxModule,
    NumberPickerModule,
    ImageListPickerModule,
    ZalamoDialogModule,
    EffectsModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    NgxMaskDirective,
    NgxMaskPipe,
    ResponsivenessModule,
    CurrenciesModule,
    ScreenRecordModule,
    CommonModule,
    AuthModule,
    OrganizationModule,
    TranslationsModule.forRoot(['login']),
    MatSelectModule,
    LanguageModule,
    NotificationsComponent,
    OrdersServicesModule,
    MatAutocompleteModule,
    MatChipsModule,
    GestureModule,
    WallartPreviewModule,
    ColorPickerDirective,
    ImagesModule,
    ImageLoaderModule,
    VirtualScrollModule,
    DateHourPickerModule,
    QuillModule.forRoot({
      modules: {
        clipboard: {
          matchVisual: false,
        },
      },
    }),
    LottieComponent,
    OrganizationMemberModule,
    RelativeTimePipeModule,
    PublicSessionOrganizationGroupNameModule,
    PublicSessionOrganizerOrganizationNameModule,
    QuickLinkModule,
    QuickCoverModule,
    WatermarkManagementModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
    SingleFileUploaderModule,
    MatProgressBarModule,
    MatInputModule,
    VisualGuideModule,
    ZalamoElementNameModule,
    ZalamoLocalClientModule,
    ZalamoPayModule,
    RouterModule.forRoot(
      [
        {
          path: 'ui-reference',
          loadChildren: () =>
            import('./ui-reference/ui-reference.module').then(
              (module) => module.UiReferenceModule,
            ),
        },
        {
          path: 'pdf',
          component: PdfTestComponent,
        },
        {
          path: 'frames',
          component: FramesComponent,
        },
        {
          path: '',
          component: ContainerComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              component: PhotographerHomeComponent,
            },
            {
              path: 'comments',
              loadChildren: () =>
                import('../../../zalamo-library/src/lib/ui/comments/comments-module-routed/comments-module-routed.module').then(
                  (m) => m.CommentsModuleRoutedModule,
                ),
            },
            {
              path: 'studio-manager',
              loadChildren: () =>
                import('./modules/studio-manager/studio-manager.module').then(
                  (m) => m.StudioManagerModule,
                ),
            },
            {
              path: 'zalamo-print',
              loadChildren: () =>
                import('../../../zalamo-library/src/lib/ui/zalamo-print-ordering/zalamo-print-ordering.module').then(
                  (m) => m.ZalamoPrintOrderingModule,
                ),
            },
            {
              path: 'watermarking',
              component: WatermarkForPhotoManagerComponent,
            },
            {
              path: 'account',
              loadChildren: () =>
                import('./modules/account/account.module').then(
                  (m) => m.AccountModule,
                ),
            },
            {
              path: 'crm',
              loadChildren: () =>
                import('./modules/crm/crm.module').then((m) => m.CrmModule),
            },
            {
              path: 'public-session-organizations',
              loadChildren: () =>
                import('./modules/public-session-organizations/public-session-organizations-router/public-session-organizations-router.module').then(
                  (m) => m.PublicSessionOrganizationsRouterModule,
                ),
            },
            {
              path: 'public-session/create-tablo-demo-session',
              component: CreateTabloDemoSessionRedirectComponent,
            },
            {
              path: 'public-sessions',
              loadChildren: () =>
                import('./modules/public-session/public-session-router.module').then(
                  (m) => m.PublicSessionRouterModule,
                ),
            },
            {
              path: 'private-sessions',
              loadChildren: () =>
                import('./modules/private-sessions/private-sessions.module').then(
                  (m) => m.PrivateSessionsModule,
                ),
            },
            {
              path: 'lookbook',
              loadChildren: () =>
                import('./modules/look-book/look-book.module').then(
                  (m) => m.LookBookModule,
                ),
            },
            {
              path: 'tos',
              loadChildren: () =>
                import('./../../../zalamo-library/src/lib/ui/tos-manager/tos-standalone/tos-standalone.module').then(
                  (m) => m.TosStandaloneModule,
                ),
            },
            {
              path: 'stocks',
              loadChildren: () =>
                import('./modules/stocks/stocks.module').then(
                  (m) => m.StocksModule,
                ),
            },
            {
              path: 'stats',
              loadChildren: () =>
                import('./modules/photographer-stats/photographer-stats.module').then(
                  (m) => m.PhotographerStatsModule,
                ),
            },
            {
              path: 'ramki',
              component: FramesQuickOrderComponent,
            },
            {
              path: 'samples',
              loadChildren: () =>
                import('./modules/product-samples/product-samples.module').then(
                  (m) => m.ProductSamplesModule,
                ),
            },
            {
              path: 'suppliers',
              loadChildren: () =>
                import('../../../zalamo-library/src/lib/ui/suppliers/suppliers.module').then(
                  (m) => m.SuppliersModule,
                ),
            },
            {
              path: 'orders',
              loadChildren: () =>
                import('../../../zalamo-library/src/lib/ui/orders/orders-routed/orders-routed.module').then(
                  (m) => m.OrdersRoutedModule,
                ),
            },
            {
              path: 'booking',
              loadChildren: () =>
                import('./modules/booking/booking.module').then(
                  (m) => m.BookingModule,
                ),
            },
            {
              path: 'config-templates',
              loadChildren: () =>
                import('./modules/config-templates/config-templates.module').then(
                  (m) => m.ConfigTemplatesModule,
                ),
            },
            {
              path: 'wallart',
              component: WallartMultiComponent,
            },
            {
              path: 'clth43xm0000008la99ct3man',
              loadChildren: () =>
                import('./modules/tracked-shooting/tracked-shooting.module').then(
                  (m) => m.TrackedShootingModule,
                ),
            },
            {
              path: 'designer',
              loadChildren: () =>
                import('./modules/designer/designer.module').then(
                  (m) => m.DesignerModule,
                ),
            },
          ],
        },
        {
          path: 'login',
          loadChildren: () =>
            import('./../../../zalamo-library/src/lib/ui/login/login-routed-module/login-routed-module.module').then(
              (m) => m.LoginRoutedModuleModule,
            ),
        },
        {
          path: 'register',
          loadChildren: () =>
            import('./../../../zalamo-library/src/lib/ui/login/register-routed-module/register-routed-module.module').then(
              (m) => m.RegisterRoutedModuleModule,
            ),
        },
        {
          path: 'qr',
          loadChildren: () =>
            import('./modules/quick-retouch/quick-retouch.module').then(
              (m) => m.QuickRetouchModule,
            ),
        },
        {
          path: 'v',
          component: VersionComponent,
        },
        {
          path: 'pr',
          component: ProtectedImageComponent,
        },
        {
          path: 'w',
          component: WallartComponent,
        },
        {
          path: 'at',
          component: AlbumTestComponent,
        },
        {
          path: 'colorize',
          component: ColorizeComponent,
        },
        {
          path: 'pc',
          component: PickerComponent,
        },
        {
          path: 'animatrix',
          component: AnimatrixComponent,
        },
        {
          path: 'vguide',
          component: VisualGuideTesterComponent,
        },
        {
          component: IframeBridgeComponent,
          path: 'iframe-bridge',
        },
        {
          path: 'p',
          component: PrintsComponent,
        },
        {
          path: 'wd',
          component: WallDecorSceneCreatorComponent,
        },
        {
          path: 'astats',
          component: KstatsComponent,
        },
        {
          path: 'd',
          component: DesignerComponent,
        },
        {
          path: 'sw',
          component: SwipeableComponent,
        },
        {
          path: 'aichallange',
          component: AiChallangeComponent,
        },
        {
          path: 'tt',
          component: ChildNameTestingComponent,
        },
        {
          path: 'cn',
          component: CnComponent,
        },
        {
          component: ZalamoPayRegisterP24Component,
          path: 'zp',
        },
        {
          component: SsltestComponent,
          path: 'ssltest',
        },
      ],
      {
        enableTracing: false,
      },
    ),
    TabloGeneratorModule,
    WallDecorFrontModule,
    MatDialogModule,
    ReactiveFormsModule,
    ClipboardModule,
    CheckboxModule,
    SwipeableModule,
    MatCheckboxModule,
    FormsModule,
    MatTooltipModule,
    LuxonModule,
    MatIconModule,
    NgScrollbarModule,
    NgScrollbarCdkVirtualScroll,
    MatButtonModule,
    MatSnackBarModule,
    ScrollingModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    ...devModules,
    HideFromOrganizationMemberModule,
  ],
  providers: [
    Apollo,
    provideNgxMask(),
    provideLottieOptions({ player: playerFactory }),
    {
      provide: IS_DEV,
      useValue: !environment.production,
    },
    ApmService,
    {
      provide: USER_PROVIDED_META_REDUCERS,
      useFactory: getMetaReducers,
    },
    {
      provide: JWT_AUTH_STATE_CLEANUP_HANDLERS,
      multi: true,
      deps: [OrderListCacheService],
      useFactory: (orderListCacheService: OrderListCacheService) => () =>
        orderListCacheService.clear(),
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (
        device: DeviceService,
        jwtService: JWTService,
      ): ApolloClientOptions => {
        const uri = environment.graphqlUrl;
        console.log(uri);
        console.log(Symbol.observable);
        console.log(observable);
        // Get the authentication token from local storage if it exists
        const token = localStorage.getItem('photographerToken');
        const auth = setContext((operation, context) => ({
          headers: {
            Authorization: `Bearer ${jwtService.getToken()}`,
            DeviceId: device.deviceId,
            // OrganizationId: organizationService.lastOrganizationId,
          },
        }));
        const serializeMap = {};
        // @ts-ignore
        const wait = new ApolloLink((operation, forward) => {
          const { serialize } = operation.getContext();
          // console.log('Serialize MAP', operation.getContext());
          if (!serialize) {
            return forward(operation);
          }
          console.log(serializeMap);
          const nextStep = new Observable((subscriber) => {
            forward(operation)
              .pipe(
                mapApolloResult((res) => {
                  console.log('RESULTS', res);
                  serializeMap[serialize].splice(
                    serializeMap[serialize].indexOf(nextStep, 1),
                  );
                  return res;
                }),
              )
              .subscribe((res) => {
                subscriber.next(res);
              });
          }).pipe(shareReplay());
          return of(null).pipe(
            switchMap(() => {
              if (
                typeof serializeMap[serialize] === 'undefined' ||
                serializeMap[serialize].length === 0
              ) {
                serializeMap[serialize] = [nextStep];
                return of(null);
              } else {
                const next = zip(...serializeMap[serialize]).pipe(
                  tap((x) => console.log('FORK JOIN', x)),
                  tap(() => {
                    if (serialize) {
                      // serializeMap[serialize].shift();
                    }
                  }),
                );
                serializeMap[serialize].push(nextStep);
                return next;
              }
            }),
            switchMap(() => nextStep),
          );
        });
        const errorHandler = new ErrorLink(({ error }) => {
          const { graphQLErrors, networkError } = apolloErrorDetails(error);

          console.log(graphQLErrors);
          if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) => {
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
              );
              if (
                message === 'Unauthorized' ||
                message === 'Unauthorized error'
              ) {
                void jwtService.logout();
              } else {
                // messageService.add({
                //   severity: 'error',
                //   summary: 'Wystąpił błąd',
                //   detail: message,
                //   sticky: true,
                //   closable: true,
                // });
              }
            });
          }
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
        });
        const wsLink = ApolloLink.from([
          auth,
          errorHandler,
          new GraphQLWsLink(
            createClient({
              url: environment.wssGraphqlUrl,
              retryAttempts: Infinity,
              on: {
                connected: () => {
                  if (websocketConnectedForFirstTime) {
                    websocketReconnected.next(undefined);
                  }
                  websocketConnectedForFirstTime = true;
                },
              },
              connectionParams: () => ({
                Authorization: `Bearer ${jwtService.getToken()}`,
                DeviceId: device.deviceId,
              }),
              lazy: true,
            }),
          ),
        ]);
        const trackedFetch = (urlToFetch, options) => {
          queriesInProgress$.next(queriesInProgress$.value + 1);
          return of(null)
            .pipe(
              switchMap(() => {
                if ((options.body as string).includes('setPhotoAsUploaded')) {
                  return from(
                    fetch(urlToFetch, {
                      ...options,
                      credentials: 'include',
                    }),
                  ).pipe(
                    retryWhen((error) => error.pipe(delay(500))),
                    timeout(1000),
                  );
                } else {
                  return fetch(urlToFetch, {
                    ...options,
                    credentials: 'include',
                  });
                }
              }),
              switchMap(async (v) => {
                const text = await (await v).text();
                if (text.includes('Error: Timeout')) {
                  throw new Error('Timeout');
                }
                if (v.status === 504) {
                  throw new Error('Timeout');
                }
                return new Response(text, v);
              }),
              retry(30),
            )
            .toPromise()
            .then(
              (response) => {
                queriesInProgress$.next(queriesInProgress$.value - 1);
                return response;
              },
              (error) => {
                queriesInProgress$.next(queriesInProgress$.value - 1);
                throw error;
              },
            );
        };
        const standardHttpLink = new HttpLink({
          uri,
          credentials: 'include',
          fetch: trackedFetch,
        });
        const quickPreviewBatchLink = new BatchHttpLink({
          uri,
          batchInterval: 50,
          credentials: 'include',
          fetch: trackedFetch,
        });
        const httpLink = split(
          ({ operationName }) =>
            [
              'countOrdersInContext',
              'countOrdersInPublicSessionOrganization',
              'GetQuickCover',
              'GetQuickLink',
            ].includes(operationName),
          quickPreviewBatchLink,
          standardHttpLink,
        );
        const link = ApolloLink.from([
          wait,
          auth,
          errorHandler,
          new RetryLink({
            attempts: { max: 10 },
            delay: { max: 5000, jitter: true, initial: 5000 },
          }),
          httpLink,
        ]);
        const splitLink = split(
          ({ query }) => {
            const definition = getMainDefinition(query);
            return (
              definition.kind === 'OperationDefinition' &&
              definition.operation === 'subscription'
            );
          },
          wsLink,
          link,
        );
        return {
          cache: new InMemoryCache({
            typePolicies: {
              ...basicApolloToIdList,
              Query: {
                fields: {
                  orders: {
                    // Keep all args *except* offset so differently-filtered queries don't collide.
                    keyArgs: (args) => {
                      if (!args) return [];
                      return Object.keys(args)
                        .filter((k) => k !== 'offset')
                        .sort();
                    },
                    // existing/incoming here are the *OrdersChunk* objects.
                    merge(existing: any, incoming: any, { args }) {
                      const offset = (args?.offset as number) ?? 0;
                      const existingItems: any[] = existing?.orders ?? [];
                      const incomingItems: any[] = incoming?.orders ?? [];
                      const merged = existingItems.slice(0);
                      for (let i = 0; i < incomingItems.length; i++) {
                        merged[offset + i] = incomingItems[i];
                      }
                      return {
                        ...incoming, // keep latest chunk metadata
                        orders: merged,
                        // make sure count never goes backwards
                        allOrdersCount: Math.max(
                          existing?.allOrdersCount ?? 0,
                          incoming?.allOrdersCount ?? 0,
                        ),
                        // offset on the object is not critical; keep latest
                      };
                    },
                    // Present a tidy, hole-free view to readers of Query.orders.
                    read(existing: any) {
                      if (!existing) return existing;
                      const pruned = (existing.orders ?? []).filter(Boolean);
                      return {
                        ...existing,
                        orders: pruned,
                        allOrdersCount:
                          existing.allOrdersCount ?? pruned.length,
                        offset: 0, // normalized (optional)
                      };
                    },
                  },
                },
              },
            },
          }),
          link: splitLink,
          assumeImmutableResults: true,
          devtools: { enabled: true },
          queryDeduplication: true,
        };
      },
      deps: [DeviceService, JWTService],
    },
    NotificationService,
    {
      provide: TRANSLATION_CONTEXT,
      useValue: 'photographer-panel',
    },
    {
      provide: JWT_TOKEN_LOCATION,
      useValue: 'photographerToken',
    },
    {
      provide: IMAGE_MANAGEMENT_URL,
      useValue: environment.imagesUrl,
    },
    {
      provide: PROVIDE_USER_TYPE,
      useValue: ViewerType.photographer,
    },
    {
      provide: IS_PHOTOGRAPHER,
      useValue: true,
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    { provide: LOCALE_ID, useValue: 'pl' },
    {
      provide: CUSTOMIZATION_SCHEMA,
      useValue: [
        {
          name: 'MainMenu',
          variables: ['main-menu-background-color', 'main-menu-text-color'],
        },
        {
          name: 'OrderStatus',
          variables: [
            'order-sent',
            'order-sent-text',
            'order-ready-for-pickup',
            'order-ready-for-pickup-text',
            'order-packed',
            'order-packed-text',
            'order-in-progress',
            'order-in-progress-text',
            'prints-order-untouched-background',
            'prints-order-prepared-background',
            'prints-order-packed-background',
            'prints-order-prepared-for-lab',
            'product-order-untouched-background ',
            'product-order-designed',
            'product-order-accepted',
            'product-order-printed',
            'product-order-ordered',
            'product-order-packed',
            'digital-order-retouched',
            'digital-order-untouched',
            'digital-order-downloaded',
            'digital-order-passed',
            'digital-order-in-progress',
          ],
        },
      ] as CustomizationEditorSchema,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class PhotographerModule {
  mineOrganizations$ = this.mineOrganizations
    .fetch({})
    .pipe(pluck('data', 'mineOrganizations'));

  constructor(
    private translation: TranslationLoaderService,
    updates: SWUpdatesService,
    service: ApmService,

    private apollo: Apollo,
    private snackBar: MatSnackBar,
    private jwtService: JWTService,
    private deviceLogoutSubscriptionService: DeviceLogoutSubscriptionService,
    zalamoTime: ZalamoTimeService,
    store: Store,
    private mineOrganizations: MineOrganizationsGQL,
  ) {
    this.deviceLogoutSubscriptionService.start();

    store
      .pipe(
        select(selectAuthStateState),
        filter(({ loggedIn }) => loggedIn),
        switchMap(() => {
          return this.mineOrganizations$.pipe(
            tap((res) => {
              store.dispatch(
                setCurrentOrganization({
                  organizationId:
                    (localStorage.lastZalamoOrganizationId &&
                      res.find(
                        (v) =>
                          v.organizationId ===
                          localStorage.lastZalamoOrganizationId,
                      )?.organizationId) ??
                    res[0].organizationId,
                }),
              );
            }),
          );
        }),
      )
      .subscribe();


    zalamoTime.checkTime();






    websocketReconnected.subscribe(() => {
      // snackBar.open('Przywrócono połączenie', null, {
      //   duration: 1000,
      // });
      if (this.jwtService.isLoggedIn()) {
        console.log('reset store');
        this.apollo.client.resetStore();
      }
      zalamoTime.checkTime();
    });
  }
}
